import { render, staticRenderFns } from "./TeikejasRengiamiTab.vue?vue&type=template&id=b19438ea&scoped=true&"
import script from "./TeikejasRengiamiTab.vue?vue&type=script&lang=js&"
export * from "./TeikejasRengiamiTab.vue?vue&type=script&lang=js&"
import style0 from "./TeikejasRengiamiTab.vue?vue&type=style&index=0&id=b19438ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19438ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VRow,VTab,VTabs,VTabsItems,VTabsSlider})
